import 'css-chunksrc/client/common/resourcesPicker/resource/styles.scss';export default {
  "resource": "_resource_p19d0_1",
  "icon": "_icon_p19d0_26",
  "user": "_user_p19d0_30",
  "avatar": "_avatar_p19d0_39",
  "name": "_name_p19d0_50",
  "removeIconContainer": "_removeIconContainer_p19d0_59"
};